module.exports = __webpack_public_path__ + "img/shymkent1.a079afb6.jpg";